<template>
    <footer class="app-footer">
        codespace&copy; 2019
    </footer>
</template>
<script>
    export default {
        name: 'footer'
    }
</script>



// WEBPACK FOOTER //
// Footer.vue?5ceb4240